import * as Types from './types.generated';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type TeamPermissionsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type TeamPermissionsQuery = { __typename?: 'Query', teamPermissions: Array<Types.TeamPermission> };


export const TeamPermissionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"teamPermissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teamPermissions"}}]}}]} as unknown as DocumentNode<TeamPermissionsQuery, TeamPermissionsQueryVariables>;